import React, { createContext, useState, ReactNode } from 'react';
import { Data } from './types/TypeData';
import { TypeSettings } from './types/TypeSettings';

interface ModalContextProps {
  isModalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalContext = createContext<ModalContextProps>({
  isModalOpen: false,
  setModalOpen: () => { },
});

export const ModalContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <ModalContext.Provider value={{ isModalOpen, setModalOpen }}>
      {children}
    </ModalContext.Provider>
  );
};


interface RenderContextProps {
  rerender: boolean;
  setRerender: React.Dispatch<React.SetStateAction<boolean>>;
  settings: TypeSettings[]
  setSettings: React.Dispatch<React.SetStateAction<TypeSettings[]>>
}

export const RenderContext = createContext<RenderContextProps>({
  rerender: false,
  setRerender: () => { },
  settings: [],
  setSettings: () => { },
});

export const RenderContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [rerender, setRerender] = useState<boolean>(false);
  const [settings, setSettings] = useState<TypeSettings[]>([])

  return (
    <RenderContext.Provider value={{ rerender, setRerender, settings, setSettings }}>
      {children}
    </RenderContext.Provider>
  );
};

interface DataContextProps {
  modalContextData: {
    fixed: Data[];
    move: Data[];
  };
  setModalData: React.Dispatch<React.SetStateAction<{
    fixed: Data[];
    move: Data[];
  }>>
}

export const DataContext = createContext<DataContextProps>({
  modalContextData: { fixed: [], move: [] },
  setModalData: () => { },
});

export const DataContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [modalContextData, setModalData] = useState<{ fixed: Data[], move: Data[] }>({ fixed: [], move: [] });

  return (
    <DataContext.Provider value={{ modalContextData, setModalData }}>
      {children}
    </DataContext.Provider>
  );
};

// LikeButtonされたかどうか

interface LikeButttonContextProps {
  LikeFlag: boolean;
  setLikeFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
export const LikeButtonFlagContext = createContext<LikeButttonContextProps>({
  LikeFlag: false,
  setLikeFlag: () => { },
});

export const LikeButtonFlagContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [LikeFlag, setLikeFlag] = useState<boolean>(false);
  return (
    <LikeButtonFlagContext.Provider value={{ LikeFlag, setLikeFlag }}>
      {children}
    </LikeButtonFlagContext.Provider>
  );
};

// buttonカードの画像の位置と詳細画面の画像の位置をリンクさせる

interface ImagePageContextProps {
  ImagePage: { page: number, direction: number };
  setPage: React.Dispatch<React.SetStateAction<{ page: number, direction: number }>>;
}
export const ImagePageContext = createContext<ImagePageContextProps>({
  ImagePage: { page: 0, direction: 0 },
  setPage: () => { }
});

export const ImagePageContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [ImagePage, setPage] = useState({ page: 0, direction: 0 });
  return (
    <ImagePageContext.Provider value={{ ImagePage, setPage }}>
      {children}
    </ImagePageContext.Provider>
  );
};